var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 45,
    viewBox: "0 0 37 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25181 56.0006C14.3568 56.0006 18.5 51.8193 18.5 46.6673V37.334H9.25181C4.14683 37.334 0.00366211 41.5153 0.00366211 46.6673C0.00366211 51.8193 4.14683 56.0006 9.25181 56.0006Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00366211 27.9993C0.00366211 22.8473 4.14683 18.666 9.25181 18.666H18.5V37.3327H9.25181C4.14683 37.3327 0.00366211 33.1513 0.00366211 27.9993Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00366211 9.33333C0.00366211 4.18133 4.14683 0 9.25181 0H18.5V18.6667H9.25181C4.14683 18.6667 0.00366211 14.4853 0.00366211 9.33333Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H27.7482C32.8531 0 36.9963 4.18133 36.9963 9.33333C36.9963 14.4853 32.8531 18.6667 27.7482 18.6667H18.5V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9963 27.9993C36.9963 33.1513 32.8531 37.3327 27.7482 37.3327C22.6432 37.3327 18.5 33.1513 18.5 27.9993C18.5 22.8473 22.6432 18.666 27.7482 18.666C32.8531 18.666 36.9963 22.8473 36.9963 27.9993Z",
    fill: "#1ABCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.bee5059a8ea82965b9822fc4084b816e.svg";
export { ForwardRef as ReactComponent };